import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DashboardSections, PortalActionScope, User } from "../../../app/_models";
import { UserService } from "../../../app/_services";
import { DoughnutChartData, InlineTableData } from "../data-visualization";
import { DashboardTabAbstractComponent } from "../dashboard-tab-abstract.component";
import { ReportDimensions } from "../../reports/models/reports";
import {
  actionsByDestination,
  actionsByDestinationHeaders,
  actionsByDestinationLegend,
  applyPortalActionsScope,
  campaigns,
  clicksByDestination,
  clicksByDestinationHeaders,
  clicksByDestinationLegend,
  faqs,
  marketplaceSummaryCells,
  overviewAiInsights,
  overviewHints,
  overviewSummaryHasActivity,
  portalActions,
  portalActionsViews,
  portalMoments,
  portalMomentsNameColumn,
  portalMomentsValueColumns,
  resolvePerformanceStats,
  retentionSummaryCells,
  retentionSummaryReportOptions,
  retentionSummaryDashboardOptions,
  returnSummaryCells,
  sessions,
  supportSummaryCells,
  topFaqsNameColumn,
  topFaqsValueColumns,
  topIntentsDoughnutData,
  topIntentsTableData,
} from "./index";

@Component({
  selector: "app-overview",
  templateUrl: "./overview.component.html",
  styleUrls: ["./../dashboard-section.scss", "./../dashboard-section-v2.scss"],
})
export class OverviewComponent extends DashboardTabAbstractComponent implements OnInit {
  @Input() cardsLoading: boolean = false;
  @Input() returnCardsLoading: boolean = false;
  @Output() reportNavigate = new EventEmitter<{ dimension: string; section: DashboardSections }>();
  @Output() sectionNavigate = new EventEmitter<DashboardSections>();
  @Output() sessionFilterChange = new EventEmitter<void>();
  @Output() supportReportNavigate = new EventEmitter<string>();
  @Output() portalActionsScopeChange = new EventEmitter<PortalActionScope>();
  dashboardSections = DashboardSections;
  reportDimensions = ReportDimensions;
  currentUser: User;
  isDashboardSession: boolean = true

  /* Cards Data */
  supportSummaryCells = supportSummaryCells;
  retentionSummaryCells = retentionSummaryCells;
  retentionSummaryReportOptions = retentionSummaryReportOptions;
  retentionSummaryDashboardOptions = retentionSummaryDashboardOptions;
  marketplaceSummaryCells = marketplaceSummaryCells;
  returnSummaryCells = returnSummaryCells;
  summaryHasActivity = overviewSummaryHasActivity;

  /* Charts Data */
  campaigns = campaigns;
  faqs = faqs;
  overviewAiInsights = overviewAiInsights;
  sessions = sessions;
  topIntentsDoughnutData: DoughnutChartData = topIntentsDoughnutData;
  topIntentsTableData: InlineTableData = topIntentsTableData;
  portalActions = portalActions;
  portalMoments = portalMoments;
  portalMomentsNameColumn = portalMomentsNameColumn;
  portalMomentsValueColumns = portalMomentsValueColumns;
  portalActionsViews = portalActionsViews;
  resolvePerformanceStats = resolvePerformanceStats;
  clicksByDestination: DoughnutChartData = clicksByDestination;
  clicksByDestinationLegend: InlineTableData = clicksByDestinationLegend;
  clicksByDestinationHeaders: string[] = clicksByDestinationHeaders;
  actionsByDestination: DoughnutChartData = actionsByDestination;
  actionsByDestinationLegend: InlineTableData = actionsByDestinationLegend;
  actionsByDestinationHeaders: string[] = actionsByDestinationHeaders;
  topFaqsNameColumn = topFaqsNameColumn;
  topFaqsValueColumns = topFaqsValueColumns;

  /* Misc */
  overviewHints = overviewHints;

  constructor(private userService: UserService) {
    super();
  }

  navigateToReport(dimension: string, section: DashboardSections) {
    this.reportNavigate.emit({ dimension, section });
  }

  navigateToDashboard(section: DashboardSections) {
    this.sectionNavigate.emit(section);
  }

  navigateToSupportReport(dimension?: string) {
    this.supportReportNavigate.emit(dimension);
  }

  async ngOnInit() {
    this.userService.getCurrent().subscribe((user: User) => {
      this.currentUser = user;
    });
  }

  onPortalActionsViewChange(value: PortalActionScope) {
    applyPortalActionsScope(this.portalActions, value);
    this.portalActionsScopeChange.emit(value);
  }

  onSessionFilterToggle(key: "includeTestSessions" | "includeHangups" | "includeUnknowns", event) {
    this.sessions.filters[key] = event.target.checked;
    this.sessionFilterChange.emit();
  }
}
